import { useEffect, useState } from 'react';
import { Product, Variant } from 'shared/types/product';
import { gtmViewItem } from 'helpers/utils/gtm-events/gtmEccomerce';
import { LineItemMapper } from 'helpers/utils/gtm-events/mapper/LineItemMapper';
import { useCart, useAccount } from 'frontastic/hooks';
import ProductTile from './ProductTile';

interface Props {
  product: Product;
  defaultVariant?: Variant;
  onAddToCart?: () => void;
}
const ProductTileQuickView = ({ product, defaultVariant, onAddToCart }: Props) => {
  const [selectedVariant, setSelectedVariant] = useState<Variant>();
  const { account, isResolved } = useAccount();

  const { data: cart } = useCart();
  useEffect(() => {
    if (defaultVariant) {
      setSelectedVariant(defaultVariant);
    } else if (product && product.masterVariant) {
      setSelectedVariant(product.masterVariant);
    }
  }, [product, defaultVariant]);

  const selectedColor = selectedVariant?.attributes?.actualColor;
  const selectedSize = selectedVariant?.attributes?.size;
  useEffect(() => {
    if (selectedVariant && isResolved) {
      gtmViewItem({
        itemDataLayer: LineItemMapper.fromProductToItemDataLayer(product, 1, selectedVariant),
        cart,
        account,
      });
    }
  }, [selectedVariant, isResolved]);

  return (
    <ProductTile
      product={product}
      selectedColor={selectedColor}
      labelSelectedColor={selectedColor}
      selectedSize={selectedSize}
      selectedVariant={selectedVariant}
      isQuickView={true}
      setSelectedVariant={(variant) => setSelectedVariant(variant)}
      onAddToCart={onAddToCart}
    />
  );
};

export default ProductTileQuickView;
